import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import BasicModal from './BasicModal';
import { CustomTextInput } from './CustomTextInput';
import CustomMobileInput from './CustomMobileInput';

const UserDetailsDialog = ({
  open,
  onClose,
  userDetails = {},
  handleChange,
  handleSubmit,
  disabled = false,
  error = {},
}) => {
  const { t } = useTranslation();

  const {
    first_name = '',
    last_name = '',
    username = '',
    email = '',
    mobile_number = '',
  } = userDetails;

  return (
    <BasicModal
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={handleSubmit}
      title={t('UserTitle')}
      cancelText={t('Cancel')}
      submitText={t('Submit')}
    >
      <div className="user-details-form">
        {/* First Name */}
        <CustomTextInput
          autoFocus
          placeholder={t('First_Name')}
          value={first_name}
          onChange={(e) => handleChange('first_name', e.target.value)}
          disabled={disabled}
        />
        {error.first_name && <span className="error">{error.first_name}</span>}

        {/* Last Name */}
        <CustomTextInput
          placeholder={t('Last_Name')}
          value={last_name}
          onChange={(e) => handleChange('last_name', e.target.value)}
          disabled={disabled}
        />
        {error.last_name && <span className="error">{error.last_name}</span>}

        {/* Email (read-only or editable — your choice) */}
        <CustomTextInput
          placeholder={t('Email')}
          value={email}
          disabled={disabled}
          onChange={(e) => handleChange('email', e.target.value)}
        />
        {error.email && <span className="error">{error.email}</span>}

        {/* Mobile */}
        <CustomMobileInput
          value={mobile_number}
          handleSetMobile={(value) => handleChange('mobile_number', value)}
          disabled={disabled}
          hasError={!!error.mobile_number}
        />
        {error.mobile_number && (
          <span className="error">{error.mobile_number}</span>
        )}
      </div>
    </BasicModal>
  );
};

export default memo(UserDetailsDialog);
